var description = '_1axj60h0 _14wijgr9';

export { description };
//# sourceMappingURL=description.css.js.map
